import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { ItemsService } from './../../../common/services/items.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { Device } from '../../../common/interfaces/item.interface';
import { SharedProgrammingService } from './../../../common/services/shared-programming.service';
import { QuickstartRemotesService } from '../quickstart-remotes.service';
import { Room, Location } from './../../../common/interfaces/item.interface';
import { ProgrammingUtilsService as Utils } from './../../../common/services/utils.service';
import { QuickstartKeypadsService } from './../../quickstart-keypads/services/keypads.service';

@Component({
  selector: 'prg-select-room',
  templateUrl: './select-room.component.html',
  styleUrls: ['./select-room.component.less']
})
export class SelectRoomComponent extends BaseRoutingComponent implements OnInit {

  allRooms: Observable<Room[]>

  constructor(
    protected router: Router,
    protected store: Store<any>,
    private shared: SharedProgrammingService,
    private remotes: QuickstartRemotesService,
    private items: ItemsService,
    private route: ActivatedRoute
  ) {
    super();
    this.allRooms = this.items.itemsList.filter(i => !!i).map(items => items.filter(itm => itm.type === 8));
  }

  ngOnInit() {
    this.shared.clearError();
  }

  roomSelected(room: Location) {
    this.remotes.setSelectedRoom(room);
    this.router.navigate(['../button'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-system-remotes/select-room/select-room.component.ts